import React from 'react';
import { useHistory } from 'react-router-dom';
import { SfcShellLeftNav } from '@synerg/react-components/dist/sfc-components';
import { SdfPromoBox, SdfLink } from '@synerg/react-components';
import { withSession } from '../session';
import useMenu from './menu';
import { hasUserRole } from '../common';
import { DEV_PORTAL_LINK } from '../constants';

function LeftNav({ session = {} }) {
	const history = useHistory();
	const [{ appRoutes }] = useMenu();
	const allRoutes = [...appRoutes];

	const filterRoutes = allRoutes
		.map((route) => {
			if (route.roles.find(role => session.roles.includes(role)) && route.hasOwnProperty("id")) {
				/* eslint-disable array-callback-return */
				if (route.id === "accelerator-clients" && session.clients.length < 1) {
					return;
				}
				return route;
			} else {
				return undefined;
			}
		})
		.filter((route) => route !== undefined);

	const activeItem = filterRoutes.find(({ active }) => active);

	return (
		<SfcShellLeftNav
			slot="nav"
			role="navigation"
			menuProvider={filterRoutes}
			activeItem={activeItem}
			onNavigate={(event) => {
				const { detail } = event;
				history.push(detail.pathname);
				event.preventDefault();
			}}
		>
			{hasUserRole(session.roles) && <SdfPromoBox
				slot="footer"
				className='m-3 h-xs w-60 place-self-center'
				size='sm'
				layout='vertical'
				align='left'
				variant='shadow'
				spacing='tight'
				header='Looking for more answers?'
				message="Explore API code samples, implementation guides and more by visiting ADP's Developer Resources site."
				illustration-name={'documents'}
			>
				<SdfLink className='mt-1 text-md text-left' emphasis="none" slot="cta" href={DEV_PORTAL_LINK} target="_blank">Visit developer resources</SdfLink>
			</SdfPromoBox>}
		</SfcShellLeftNav>
	);
}

export default withSession(LeftNav);
